import { Component, input } from '@angular/core';

@Component({
  selector: 'td-wb-modal-panel',
  template: '<ng-content />',
  styleUrls: ['modal-panel.component.scss'],
  host: {
    '[class.td-wb-modal-panel--top]': 'top()',
    '[class.td-wb-modal-panel--bottom]': 'bottom()',
    '[class.td-wb-modal-panel--left]': 'left()',
    '[class.td-wb-modal-panel--right]': 'right()'
  }
})
export class ModalPanelComponent {
  readonly top = input<boolean>(false);
  readonly bottom = input<boolean>(false);
  readonly left = input<boolean>(true);
  readonly right = input<boolean>(true);
}
